"use strict";
/******************/
/* COLOR SETTINGS */
/******************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.transparency = exports.color = exports.accent_color = exports.base_color = exports.player_color = exports.palette = exports.green = exports.blue = exports.yellow = exports.red = exports.white = exports.black = exports.light = exports.dark = void 0;
// Theme color
exports.dark = {
    c0: '#ffffff',
    c100: '#C5C5C5' /* #CCD7DE */,
    c200: '#ABADC6',
    c300: '#9699B3',
    c400: '#8185A0',
    c500: '#6C708D',
    c600: '#575C7A',
    c700: '#424867',
    c800: '#1f1b30',
    c900: '#070219',
};
exports.light = {
    c0: exports.dark.c900,
    c100: exports.dark.c800,
    c200: exports.dark.c700,
    c300: exports.dark.c600,
    c400: exports.dark.c500,
    c500: exports.dark.c400,
    c600: exports.dark.c300,
    c700: exports.dark.c200,
    c800: exports.dark.c100,
    c900: exports.dark.c0,
};
exports.black = {
    c0: '#ffffff',
    c100: '#BFCDCC',
    c200: '#A6B7B9',
    c300: '#8D9EA5',
    c400: '#748390',
    c500: '#5B667C',
    c600: '#424867',
    c700: '#212435',
    c800: '#1f1b30',
    c900: '#070219',
};
exports.white = {
    c0: exports.dark.c900,
    c100: exports.dark.c800,
    c200: exports.dark.c700,
    c300: exports.dark.c600,
    c400: exports.dark.c500,
    c500: exports.dark.c400,
    c600: exports.dark.c300,
    c700: exports.dark.c200,
    c800: exports.dark.c100,
    c900: exports.dark.c0,
};
// Accent colors
exports.red = {
    c0: "#FFFFFF",
    c50: "#FFD5D9",
    c100: "#FFAFB9",
    c200: "#FF8A9B",
    c300: "#FF6681",
    c400: "#FF4569",
    c500: "#FF2453",
    c600: "#C0183D",
    c700: "#810E28",
    c800: "#420614",
    c900: "#030001",
};
exports.yellow = {
    c0: "#FFFFFF",
    c50: "#FFFED4",
    c100: "#FFF9AD",
    c200: "#FFF188",
    c300: "#FDE764",
    c400: "#F9DA41",
    c500: "#F3CA20",
    c600: "#BA9A15",
    c700: "#7E680C",
    c800: "#413605",
    c900: "#030200",
};
exports.blue = {
    c0: "#FDFEFF",
    c50: "#D4ECFF",
    c100: "#ADDCFF",
    c200: "#88CEFF",
    c300: "#64C1FD",
    c400: "#41B5F9",
    c500: "#20ABF3",
    c600: "#1582BA",
    c700: "#0C587E",
    c800: "#052D41",
    c900: "#000203",
};
exports.green = {
    c0: "#FDFFFE",
    c50: "#D4F8E7",
    c100: "#ADF0CE",
    c200: "#87E7B4",
    c300: "#62DD99",
    c400: "#3ED27D",
    c500: "#1BC65F",
    c600: "#129747",
    c700: "#0B672F",
    c800: "#053518",
    c900: "#000201",
};
// Palette colo
exports.palette = {
    black: exports.dark,
    white: exports.light,
    red: exports.red,
    yellow: exports.yellow,
    blue: exports.blue,
    green: exports.green,
};
exports.player_color = [exports.palette.red.c500, exports.palette.yellow.c500, exports.palette.blue.c500, exports.palette.green.c500, "#DE28DC", "#FF7D00", "#2768c9", "#76b820", "#FF707E", "#b8b620", "#086A9B", "#34623F"];
exports.base_color = {
    light: exports.light.c900,
    light_secondary: '#CCD7DE',
    light_tertiary: '#ABADC6',
    dark: exports.dark.c900,
    dark_secondary: '#1f1b30',
    dark_tertiary: '#424867',
};
exports.accent_color = {
    important: exports.palette.red.c500,
    error: exports.palette.yellow.c500,
    warning: exports.palette.red.c500,
    success: exports.palette.green.c500,
    info: exports.palette.blue.c500,
};
exports.color = {
    dark: exports.base_color.dark,
    dark_secondary: exports.base_color.dark_secondary,
    dark_tertiary: exports.base_color.dark_tertiary,
    light: exports.base_color.light,
    light_secondary: exports.base_color.light_secondary,
    light_tertiary: exports.base_color.light_tertiary,
    primary: exports.palette.red.c500,
    secondary: exports.palette.yellow.c500,
    complementary: exports.palette.blue.c500,
    palette: exports.palette,
    player: exports.player_color,
    error: exports.accent_color.error,
    warning: exports.accent_color.warning,
    success: exports.accent_color.success,
    info: exports.accent_color.info,
};
const transparency = (mode, opacity = 0.1) => {
    if (mode === 'light') {
        return `rgba(0, 0, 0, ${opacity})`;
    }
    else {
        return `rgba(255, 255, 255, ${opacity})`;
    }
};
exports.transparency = transparency;
//# sourceMappingURL=colors.js.map